import { HISTORY_TIGERX_COLUMNS_TO_OMIT } from '@/core/config/history'
import { ExchangeHistoryItemInterface } from '@/redux/transactions/transactions.types'
import { ByBitTransactionHistory } from '@/services/bybit'
import { Statement } from '@/services/tigerx'
import { dateFormatter, tryNumberFormatter } from '@/ui/organisms/HistoryTrade/HistoryTrade.utils/utils'

export function groupTransfersByExchange(data: any[]): Record<string, any[]> {
  return data.reduce((acc, item) => {
    if (!acc[item.subExchangeType]) {
      acc[item.subExchangeType] = [] // Если ещё нет ключа, создаем массив
    }

    // Добавляем в массив transfers с добавленным полем asset
    const transfersWithAsset = item.transfers.map((transfer: any) => ({
      ...transfer,
      asset: item.coin, // Добавляем asset из coin
    }))

    // Добавляем в массив все transfers из текущего объекта
    acc[item.subExchangeType].push(...transfersWithAsset)

    return acc
  }, {} as Record<string, any[]>)
}

export function addBalancesToTransfers(
  transfersData: Record<string, any[]>,
  balancesData: any[]
): Record<string, any[]> {
  const balanceMap = new Map()

  // 1. Создаём мапу балансов, где ключ - "asset_subExchange"
  balancesData.forEach(balance => {
    const key = `${balance.asset}_${balance.subExchange}`
    balanceMap.set(key, balance.balance)
  })

  // 2. Добавляем баланс в transfersData
  Object.keys(transfersData).forEach(exchangeType => {
    transfersData[exchangeType] = transfersData[exchangeType].map(transfer => {
      const balanceKey = `${transfer.coin}_${exchangeType}`
      return {
        ...transfer,
        balance: balanceMap.get(balanceKey) || 0, // Если нет баланса, ставим 0
      }
    })
  })

  return transfersData
}

// mappers for history trade
const tigerXHistoryFormattres: Partial<Record<keyof Statement, Function>> = {
  createAt: (source: string) => dateFormatter(source),
}

export const tigerXHistoryToHistoryItem = (source: Statement): ExchangeHistoryItemInterface => {
  const cloned: Partial<Record<string, any>> = { ...source }

  Object.entries(cloned).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      delete cloned[key as keyof ByBitTransactionHistory]
    }
  })

  return Object.keys(cloned).reduce((acc, key) => {
    if (HISTORY_TIGERX_COLUMNS_TO_OMIT.includes(key as keyof Statement)) return acc
    const formatter = tigerXHistoryFormattres[key as keyof Statement]

    // Format sum from "BINANCE_SPOT_ADA_USDT" → "ADAUSDT"
    const symParts = cloned['sym']?.split('_') ?? []
    const formattedSym = symParts.slice(-2).join('')

    return {
      ...acc,
      sym: formattedSym,
      ...(formatter ? { [key]: formatter(cloned[key]) } : { [key]: tryNumberFormatter(cloned[key]) }),
    }
  }, {})
}
